import Betslip from './web/index.vue';

const _Betslip = Betslip;

export default _Betslip;